import { useGet } from '../../HttpClient';
import { AccountStatusReasonsResponse } from '@app/models';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';

export function useAccountStatusReasons(accountStatus: string) {
  const get = useGet(true, "ams");
  const getAccountStatusReasons = (accountStatus: string) => {
    return get<AccountStatusReasonsResponse>(`/api/proxy/ams/account-service/account-statuses/${accountStatus}/reasons`);
  };
  return useQueryWithErrorHandling({
    queryKey: ['get-account-status-reasons', accountStatus],
    enabled: !!accountStatus,
    queryFn: async () => await getAccountStatusReasons(accountStatus),
  });
}
